import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MoreTimeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"more_time"}/>
}
